import React, { useState } from 'react'

import { ModalInjectedProps } from '@sketch/components'

import { StyledModal } from './CreateScimPersonalAccessTokenModal.styles'

import { ScimPersonalAccessTokenFragment } from '@sketch/gql-types'

import { useCreateScimPersonalAccessToken } from '../../operations'

import CreateScimPersonalAccessTokenForm from './CreateScimPersonalAccessTokenForm'
import CopyScimPersonalAccessToken from './CopyScimPersonalAccessToken'

enum Step {
  CreateToken = 'CREATE_TOKEN',
  CopyToken = 'COPY_TOKEN',
}

type State =
  | { step: 'CREATE_TOKEN' }
  | {
      step: 'COPY_TOKEN'
      secret: string
      token: ScimPersonalAccessTokenFragment
    }

const CreateTokenModal: React.FC<ModalInjectedProps> = props => {
  const { hideModal } = props
  const [state, setState] = useState<State>({ step: 'CREATE_TOKEN' })

  const [createPersonalToken, { loading }] = useCreateScimPersonalAccessToken({
    onCompleted: ({ personalAccessToken, secret }) => {
      setState({ step: 'COPY_TOKEN', secret, token: personalAccessToken })
    },
  })

  return (
    <StyledModal title={titleFor(state.step as Step)} onCancel={hideModal}>
      {state.step === 'CREATE_TOKEN' ? (
        <CreateScimPersonalAccessTokenForm
          hideModal={hideModal}
          createPersonalToken={createPersonalToken}
          loading={loading}
        />
      ) : (
        <CopyScimPersonalAccessToken
          secret={state.secret}
          token={state.token}
          hideModal={hideModal}
        />
      )}
    </StyledModal>
  )
}

function titleFor(step: Step) {
  return step === 'CREATE_TOKEN'
    ? 'Create a Token'
    : 'SCIM Personal Token Details'
}

export default CreateTokenModal
